import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCamera } from '@fortawesome/free-solid-svg-icons';
import React from 'react';
export default {
  FontAwesomeIcon,
  faCamera,
  React
};